import React from 'react';
import AppButton from 'components/atoms/Button';
import FacebookIcon from '@material-ui/icons/Facebook';
import useStyles from './styles';
import { IAuthLoginProps } from './types';
import TranslatedText from '../TranslatedText';
import clsx from 'clsx';

const GoogleAuth = (props: IAuthLoginProps) => {
  const classes = useStyles();
  return (
    <AppButton
      text={
        props.text ?? <TranslatedText defaultText="Sign up with Facebook" />
      }
      // startIcon={<FacebookIcon />}
      variant="outlined"
      color="default"
      fullWidth
      {...props}
      className={clsx(classes.authButton, props.className)}
    />
  );
};

export default GoogleAuth;
